import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as rccActions from "../../actions/rccActions";

import SmartPurgeModalComponent from "../../components/global/modal/SmartPurgeModal";

class SmartPurgeModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseModalAction();
    };

    smartPurgeChannels = (channels) => {
        this.props.dispatchSmartPurgeChannelsAction(channels);
    };

    render() {
        return (
            <SmartPurgeModalComponent
                tabId={this.props.tabId}
                channelList={this.props.channelList}
                colorantList={this.props.colorantList}
                closeModal={this.closeModal}
                smartPurgeChannels={this.smartPurgeChannels}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        channelList: store.rcc.channelList,
        colorantList: store.global.colorantList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SMART_PURGE_MODAL));
        },
        dispatchSmartPurgeChannelsAction: (channels) => {
            dispatch(rccActions.smartPurgeChannels(channels));
        }
    };
};

export default SmartPurgeModal = connect(mapStoreToProps, mapDispatchToProps)(SmartPurgeModal);
